import {useMarkEvaluationSeenMutation} from '../queries/MarkEvaluationSeen.queries.generated';

/**
 * Marks a student assignment's feedback as read. Fire-and-forget by design: the mutation returns
 * `studentHasSeenEvaluation` on the assignment, so a success updates the normalized cache and the
 * row leaves the banner on its own, and a failure just means it is still there next time.
 */
export default function useMarkEvaluationSeen(): (studentAssignmentId: string) => Promise<void> {
  const [mutate] = useMarkEvaluationSeenMutation();

  return async (studentAssignmentId) => {
    try {
      await mutate({variables: {id: studentAssignmentId}});
    } catch {
      // Swallowed deliberately: nothing the student can act on, and the banner is self-correcting.
    }
  };
}
